/* ==============================================================================================
 * SELECT OPTIONS REMOVER
 * ============================================================================================== */

var Sushi;

(function (Sushi) {
	"use strict";

	/**
	 * @param {HTMLSelectElement} selectElement
	 * @return {void}
	 */
	Sushi.Util.removeSelectOptions = function (selectElement) {
		for (var i = selectElement.length; i > 0; i--) {
			selectElement.remove(i);
		}
	};

})(Sushi || (Sushi = {}));
